/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetEmployeeCountRequest
 */
export interface SetEmployeeCountRequest {
    /**
     * Number of employees to report for billing purposes.
     */
    employeeCount?: number;
}

/**
 * Check if a given object implements the SetEmployeeCountRequest interface.
 */
export function instanceOfSetEmployeeCountRequest(value: object): value is SetEmployeeCountRequest {
    return true;
}

export function SetEmployeeCountRequestFromJSON(json: any): SetEmployeeCountRequest {
    return SetEmployeeCountRequestFromJSONTyped(json, false);
}

export function SetEmployeeCountRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetEmployeeCountRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'employeeCount': json['employeeCount'] == null ? undefined : json['employeeCount'],
    };
}

export function SetEmployeeCountRequestToJSON(json: any): SetEmployeeCountRequest {
    return SetEmployeeCountRequestToJSONTyped(json, false);
}

export function SetEmployeeCountRequestToJSONTyped(value?: SetEmployeeCountRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employeeCount': value['employeeCount'],
    };
}

